import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { CouponItemWrapper, CouponListSection } from './styled'
import CouponItemSkeleton from 'components/Skeleton/CouponItemSkeleton'

interface CouponListSkeletonProps {
  quantity: number
  lineAvatar?: boolean
}
const CouponListSkeleton = ({ lineAvatar, quantity }: CouponListSkeletonProps) => {
  const skeletonItems = Array.from<number>({ length: quantity })

  return (
    <CouponListSection>
      <Skeleton containerClassName="info" width="100%" height={42} />
      {skeletonItems.map((_, index) => (
        <CouponItemWrapper key={index} borderTop={index !== 0}>
          <CouponItemSkeleton key={index} lineAvatar={lineAvatar} />
        </CouponItemWrapper>
      ))}
    </CouponListSection>
  )
}

export default CouponListSkeleton
